<!-- 研究成果 -->
<template>
  <div id="studyResult">
    <sidebar :content="sidebarData"></sidebar>
    <router-view></router-view>
  </div>
</template>

<script>
import sidebar from '@/components/sidebar'

export default {
  name: 'studyResult',
  data() {
    return {
      sidebarData: {
        title: '研究成果',
        sub: [
          {
            title: '出版著作',
            url: '/studyResult/publications',
            sub: []
          },
          {
            title: '学术论文',
            url: '/studyResult/academicPaper',
            sub: []
          },
          {
            title: '研究报告',
            url: '/studyResult/researchReport',
            sub: []
          },
          {
            title: '成果应用',
            url: '/studyResult/achievementApply',
            sub: []
          },
        ]
      },
    }
  },
  components: {
    sidebar,
  }
}
</script>

<style lang="scss" scoped>
  #studyResult {
    display: flex;
    width: 80%;
    margin: 0 auto;
    padding: 40px 0 160px 0;
  }
</style>